var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"d-flex flex-column w-75 mx-auto my-0 mt-2"},[_vm._l((_vm.AlertService.alerts),function(alert,ind){return [_c(alert.component,_vm._b({key:ind,tag:"component",attrs:{"data-id":alert.id,"close":alert.close,"dismiss":alert.dismiss}},'component',alert.props,false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }